import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function OrderConfirmation() {
  const [params] = useSearchParams();
  const order = params.get("order");
  return (
    <div className="mx-auto max-w-2xl px-4 py-24 text-center">
      <CheckCircle2 className="mx-auto h-14 w-14 text-kys-accent" />
      <h1 className="mt-6 font-serif text-4xl text-kys-ink">Order received</h1>
      <p className="mt-3 text-sm text-kys-charcoal">Thank you! Your order has been recorded.</p>
      {order && <p data-testid="order-number" className="mt-4 inline-block rounded-md border border-kys-blush-border bg-white px-5 py-2 font-mono text-lg text-kys-ink">{order}</p>}
      <p className="mx-auto mt-6 max-w-md text-xs text-kys-muted">
        Payment, shipping and tax are finalized once those integrations are configured. You'll receive an email confirmation once email is connected.
      </p>
      <Link to="/shop" className="mt-8 inline-flex rounded-full bg-kys-ink px-7 py-3 text-sm font-semibold text-white hover:bg-kys-accent">Keep shopping</Link>
    </div>
  );
}
